module.exports = __webpack_public_path__ + "img/jilu-img.579a5c12.png";